import React from "react";
import Banner from "../Components/Banner";

const policies = [
  {
    title: "1. Introduction",
    text: "These Terms and Conditions govern the use of services provided by HNH Soft Tech Solutions Pvt Ltd. By accessing our website or engaging our services, you agree to comply with these terms.",
  },
  {
    title: "2. Services",
    text: "HNH Soft Tech Solutions Pvt Ltd provides digital services including web development, mobile application development, UI/UX design, and digital marketing solutions. All services are delivered digitally according to the agreed project scope.",
  },
  {
    title: "3. Scope of Work",
    text: "The scope of each project will be defined in a written agreement, proposal, or email confirmation. Clients agree to provide all required materials, feedback, and approvals necessary for project completion.",
  },
  {
    title: "4. Pricing and Payment",
    text: "Service pricing varies depending on project complexity and requirements. Payment terms, including milestone payments or hourly billing, will be agreed upon before work begins. All payments are conducted in PKR and must be completed within the specified invoice period.",
  },
  {
    title: "5. Project Delivery",
    text: "All services and deliverables are provided digitally via secure file transfer, email, repository access, or server deployment. Delivery timelines are agreed upon before the start of each project.",
  },
  {
    title: "6. Refund and Cancellation",
    text: "Due to the custom nature of software development services, refunds are generally not available once work has started or deliverables have been shared. Cancellation requests may be considered before the start of a milestone.",
  },
  {
    title: "7. Confidentiality",
    text: "Both parties agree to maintain confidentiality of all proprietary information, business data, and project materials shared during the course of the project.",
  },
  {
    title: "8. Intellectual Property",
    text: "Upon full payment of the project invoice, the client receives ownership rights to the final deliverables unless otherwise specified. HNH Soft Tech Solutions Pvt Ltd reserves the right to showcase completed work in its portfolio.",
  },
  {
    title: "9. Limitation of Liability",
    text: "HNH Soft Tech Solutions Pvt Ltd shall not be liable for indirect, incidental, or consequential damages resulting from the use of our services or deliverables.",
  },
  {
    title: "10. Termination",
    text: "Either party may terminate a project with written notice. Any work completed up to the termination date must be compensated according to the agreed payment terms.",
  },
  {
    title: "11. Changes to Terms",
    text: "HNH Soft Tech Solutions Pvt Ltd reserves the right to update or modify these Terms and Conditions at any time. Updated versions will be published on this page.",
  },
  {
    title: "12. Contact Information",
    text: "For any questions regarding these Terms and Conditions, please contact us at info@hnhsofttechsolutions.com or visit our office at House No 14/09, Block-E Nazimabad No. 4, Karachi, Pakistan.",
  },
];

const TermsCondition = () => {
  return (
    <>
      <Banner heading="Terms and Conditions" text="Terms and Conditions" />

      <div className="bg-[#0b1e3a] py-16 px-4">
        <div className="max-w-5xl mx-auto space-y-6">
          {policies.map((item, index) => (
            <div
              key={index}
              className="bg-[#0f2b52] border border-blue-400/30 rounded-2xl p-6 shadow-md hover:scale-[1.02] transition"
            >
              <h3 className="text-white text-xl font-semibold mb-2">
                {item.title}
              </h3>
              <p className="text-gray-200 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TermsCondition;